import "./LineChart.scss";
import Chart from "react-apexcharts";

const LineChart = ({ keyword, time, postsAnalyzed, data }) => {
  let xValues = [];
  let yValues = [];

  for (let i = 0; i < data.length; i++) {
    xValues.push(data[i][0]);
    yValues.push(data[i][1]);
  }

  const xLabel = `Date of Post`;
  const yLabel = "Number of Posts";
  const title = `Top Posts Mentioning ${
    keyword[0].toUpperCase() + keyword.slice(1)
  } Over Time (${time})`;

  const input = {
    options: {
      colors: ["#1491ff"],
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
      },

      title: {
        text: title,
        style: { fontSize: "18px", fontFamily: "revert" },
        align: "left",
      },
      markers: {
        size: 5,
      },
      xaxis: {
        categories: xValues,
        title: {
          text: xLabel,
          style: { fontSize: "14px", fontFamily: "revert" },
          margin: -50,
          floating: true,
          offsetY: 0,
        },

        // hide x labels
        labels: { show: true },
      },
      yaxis: {
        title: {
          text: yLabel,
          style: {
            fontSize: "14px",
            fontFamily: "revert",
          },
          offsetX: 0,
        },
        labels: {
          show: true,
          style: { fontSize: "14px", fontFamily: "revert" },
          maxWidth: 260,
        },
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0.5,
        },
      },
      // data labels
      dataLabels: {
        textAnchor: "middle",
      },
    },
    series: [
      {
        name: "Number of Posts", // seriesName,
        data: yValues, //values,
      },
    ],
  };

  return (
    <article className={`dashboard__linechart`}>
      <Chart
        options={input.options}
        series={input.series}
        type="line"
        id={`linechart`}
        width="100%"
        height="315"
      />
    </article>
  );
};

export default LineChart;
